import { useParams } from "react-router-dom";
import InvoiceDisplay from "../../components/history/display/InvoiceDisplay";

const InvoicePage = () => {
  const params = useParams();

  return (
    <InvoiceDisplay id={params.id} invoiceNumber={params.invoiceNumber} />
  );
};

export default InvoicePage;